import { render, staticRenderFns } from "./Expo2025.vue?vue&type=template&id=457b66a4&scoped=true&"
import script from "./Expo2025.vue?vue&type=script&lang=js&"
export * from "./Expo2025.vue?vue&type=script&lang=js&"
import style0 from "./Expo2025.vue?vue&type=style&index=0&id=457b66a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457b66a4",
  null
  
)

export default component.exports